import axios from 'axios';
import { ErrorParams, TokenParams } from '../constants';
import { getQueryParamByKey } from './param-util';
import { REACT_APP_NODE_ENV, REACT_APP_LOCAL_TOKEN_URL } from '../config';

export const getSecAuthZToken = (clientId, permissions) => {
  return new Promise(async (resolve, reject) => {
    const appTokenUrl = REACT_APP_LOCAL_TOKEN_URL;
    const appTokenRequest = {
      pai: clientId || 'ONP_CONSENT_SUBSCRIBER',
      per: permissions,
    };
    axios
      .post(appTokenUrl, appTokenRequest)
      .then(({ data }) => {
        resolve(data?.access_token);
      })
      .catch((e) => reject(e));
  });
};

export const getToken = async (clientId) => {
  const isLocal = REACT_APP_NODE_ENV === 'local';
  if (isLocal) {
    return getSecAuthZToken(clientId, ['ONP_CONSENT_SUBSCRIBER_R', 'ONP_CONSENT_SUBSCRIBER_W']);
  } else {
    return getQueryParamByKey(TokenParams.idToken);
  }
};

export const deleteInvalidKeys = (obj) => {
  Object.keys(obj).forEach((key) => (obj[key] === undefined || obj[key] === null) && delete obj[key]);
};

export const getErrorProps = (e) => {
  const { message, response } = e;
  const status = response?.status;
  const error = response?.data?.error;

  const errorProps = {
    [ErrorParams.code]: error?.code,
    [ErrorParams.desc]: error?.description,
    [ErrorParams.msg]: message,
    [ErrorParams.status]: status,
    [ErrorParams.subcode]: error?.subcode,
    [ErrorParams.moreInfo]: error?.moreInfo,
    [ErrorParams.addInfo]: error?.additionalInfo,
    [ErrorParams.subDesc]: error?.subCodeDescription,
  };
  deleteInvalidKeys(errorProps);
  return errorProps;
};

export class OnpError extends Error {
  constructor(code, description, subcode, subCodeDescription, moreInfo, additionalInfo) {
    super(description); // (1)
    const response = {
      data: {
        error: {
          code,
          description,
          subcode,
          subCodeDescription,
          moreInfo,
          additionalInfo,
        },
      },
    };
    this.response = response;
  }
}

export const getVinsToConsent = (eligibleVehResp) => {
  const eligibleVins = eligibleVehResp?.eligibleVehicles?.eligibleVins;
  if (eligibleVins instanceof Array) {
    return eligibleVins.filter((vehicle) => vehicle.isSelected).map((vehicle) => vehicle);
  } else {
    return [];
  }
};

export const getVinsToRevoke = (eligibleVehResp) => {
  const eligibleVins = eligibleVehResp?.eligibleVehicles?.eligibleVins;
  if (eligibleVins instanceof Array) {
    return eligibleVins.filter((vehicle) => vehicle.isConsented && !vehicle.isSelected).map((vehicle) => vehicle);
  } else {
    return [];
  }
};

export const isTruthy = (value) => {
  return value && value !== 'null' && value !== 'undefined';
};
